import {http} from '@/http'

export default {
  getUbigeos() {
    return http.get('api/v1/ubigeo');
  },
}
